const Debounce = (callback: (...params: any[]) => any, ms = 300) => {
    let timeoutId: ReturnType<typeof setTimeout>;
    return function (this: any, ...args: any[]) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => callback.apply(this, args), ms);
    };
};

export default Debounce;
